import { api } from './config.js'

export const reilmAPI = {
    createUser : async function (body) {
        const response = await api.request({
            url: '/users',
            method: "POST",
            data: body
        })

        return response;
    },

    loginUser : async function (body) {
        const response = await api.request({
            url: '/auth/login',
            method: "POST",
            data: body
        })

        return response;
    },

    getCurrentUser : async function () {
        const response = await api.request({
            url: '/auth/me',
            method: "GET",
        })

        return response;
    },

    logoutUser : async function () {
        const response = await api.request({
            url: '/auth/logout',
            method: "POST",
        })

        return response;
    },

    refreshToken : async function () {
        const response = await api.request({
            url: '/auth/refresh',
            method: "POST",
        })

        return response;
    },

    createSubscription : async function (body) {
        const response = await api.request({
            url: '/stripe/create-subscription',
            method: "POST",
            data: body
        })

        return response;
    },

    getSubscriptionStatus : async function () {
        const response = await api.request({
            url: '/stripe/subscription-status',
            method: "GET",
        })

        return response;
    },

    forgotPassword : async function (body) {
        const response = await api.request({
            url: '/auth/forgot-password',
            method: "POST",
            data: body
        })

        return response;
    },

    resetPassword : async function (body) {
        const response = await api.request({
            url: '/auth/reset-password',
            method: "POST",
            data: body
        })

        return response;
    },

    getUser : async function (body) {
        const response = await api.request({
            url: '/get-user',
            method: "POST",
            data: body
        })

        return response;
    },

    savePropertyDetails : async function (body) {
        const response = await api.request({
            url: '/properties',
            method: "POST",
            data: body
        })

        return response;
    },

    updatedPropertiesDetails : async function (id, body) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "PATCH",
            data: body
        })

        return response;
    },

    archivePropertiesBatch : async function (body) {
        const response = await api.request({
            url: '/properties/bulk/archive',
            method: "PATCH",
            data: body
        })

        return response;
    },

    deleteProperty : async function (id) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "DELETE",
        })

        return response;
    },

    deletePropertiesBatch : async function (body) {
        const response = await api.request({
            url: '/properties/bulk',
            method: "DELETE",
            data: body
        })

        return response;
    },

    getTags: async function () {
        const response = await api.request({
            url: '/tags',
            method: "GET",
        })
        return response;
    },

    createTag: async function (body) {
        const response = await api.request({
            url: '/tags',
            method: "POST",
            data: body,
        })
        return response;
    },

    updateTag: async function (id, body) {
        const response = await api.request({
            url: `/tags/${id}`,
            method: "PATCH",
            data: body,
        })
        return response;
    },

    deleteTag: async function (id) {
        const response = await api.request({
            url: `/tags/${id}`,
            method: "DELETE",
        })
        return response;
    },

    getProperties: async function () {
        const response = await api.request({
            url: '/properties',
            method: "GET",
        })
        return response;
    },

    getProperty: async function (id) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "GET",
        })
        return response;
    },

    toggleArvComp: async function (propertyId, compId, archived) {
        const response = await api.request({
            url: `/properties/${propertyId}/arv/comps/${compId}`,
            method: 'PATCH',
            data: { archived },
        })
        return response
    },

    searchArvComps: async function (id, criteria) {
        const response = await api.request({
            url: `/properties/${id}/arv/search`,
            method: 'POST',
            data: criteria,
        })
        return response
    },

    searchAddress: async function (body) {
        const response = await api.request({
            url: '/realtor/autocomplete',
            method: 'GET',
            params: { input: body },
        })
        return response;
    },

    realtorPropertyDetail: async function (body) {
        const response = await api.request({
            url: '/realtor/detail',
            method: 'GET',
            params: { propertyId: body },
        })
        return response;
    },

}